/**
 * Upper bound on the page size a request may ask for. Every list and search
 * endpoint pages through the same decoder, so this is the most rows one API
 * call returns; the client's largest page is 256.
 */
export const maxPageSize = 1000;
